import { render, staticRenderFns } from "./DashboardCard.vue?vue&type=template&id=3e0130f0"
import script from "./DashboardCard.vue?vue&type=script&lang=js"
export * from "./DashboardCard.vue?vue&type=script&lang=js"
import style0 from "./DashboardCard.vue?vue&type=style&index=0&id=3e0130f0&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports